module.exports = __webpack_public_path__ + "static/media/vaccinations@2x.5f6eae25.png";